<template>
  <div class="text-left mx-3">
    <div class="row">
      <div class="col col-sm-6">
        <div class="d-flex align-items-center">
          <h3 class="font-weight-bolder mt-2">Crew Activity</h3>
          <div class="ml-2">
            <button class="btn btn-xs text-smaller btn-primary"
              data-toggle="modal" data-target="#crew-experience-modal"
            >
              <i class="fa fa-list" aria-hidden="true"></i>
              Total Experience
            </button>
          </div>
        </div>
      </div>
      <div class="col col-sm-6 my-auto">
        <template v-if="((isDesignatedPrincipal || isPrincipal || isPrincipalStaff) || isBremen) && !notToBeReemployed && !guest && !isKline">
          <template v-if="crew.active == 1 || isSystemAdmin">
            <button class="btn btn-sm btn-xs btn-outline-primary text-small font-weight-bold float-right hideOnPrint"
                    data-toggle="modal" data-target="#addCrewActivity"
            >
              <span class="fas fa-plus"></span>
              Add New
            </button>
          </template>
        </template>
      </div>

      <div class="col col-sm-12">
        <form @submit.prevent="searchCrewActivities">
          <table class="table table-hover table-bordered table-template-1 text-small border-dark">
            <thead>
            <tr>
              <th rowspan="2" class="col-index" v-if="isSystemAdmin">ID</th>
              <th rowspan="2" class="col-index">#</th>
              <th rowspan="2" v-if="isSystemAdmin"
                  style="width: 50px;"
              >Last<br/>Updated By
              </th>
              <th rowspan="2" class="col-code">Act. Code</th>
              <th rowspan="2" class="col-code" style="width: 7%">Rank / Position</th>
              <th colspan="3">Vessel/Office</th>
              <th colspan="3">Start/Embarkation</th>
              <th colspan="4">End/Disembarkation</th>
              <th rowspan="2" class="col-code">Period</th>
              <th rowspan="2" class="col-code">CER</th>
              <th rowspan="2" class="col-date-time">Last<br/>Updated At</th>
              <th rowspan="2" class="col-code hideOnPrint">Action</th>
            </tr>
            <tr>
              <th>Name</th>
              <th class="col-name">Type</th>
              <th class="col-name">Flag</th>
              <th class="col-date">Date</th>
              <th class="col-code">Status</th>
              <th class="col-code">Port</th>
              <th class="col-date">Date</th>
              <th class="col-code">Status</th>
              <th class="col-code">Port</th>
              <th class="col-code">Reason</th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td class="p-0" v-if="isSystemAdmin">
              </td>
              <td class="p-0" v-if="isSystemAdmin">
              </td>
              <td class="p-0" v-if="isSystemAdmin">
              </td>
              <td class="p-0" :colspan="isSystemAdmin ? 1 : 2">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Activity Code"
                       v-model="params.actCode"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Rank"
                       v-model="params.rank"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Vessel Name"
                       v-model="params.vessel"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Vessel Type"
                       v-model="params.vesselType"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Vessel Type"
                       v-model="params.flag"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Embarkation Date"
                       v-model="params.startDate"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Start Embarkation Status"
                       v-model="params.startStatus"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Start Embarkation Port"
                       v-model="params.startPort"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search Disembarkation Date"
                       v-model="params.endDate"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search End Disembarkation Status"
                       v-model="params.endStatus"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search End Disembarkation Port"
                       v-model="params.endPort"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Search End Disembarkation Reason"
                       v-model="params.endReason"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="Period"
                       v-model="params.period"
                       @input="searchCrewActivities"
                >
              </td>
              <td class="p-0">
                <input type="text"
                       class="form-control form-control-xs"
                       title="CER"
                       v-model="params.cers"
                       @input="searchCrewActivities"
                >
              </td>
              <td></td>
              <td class="p-0 text-center hideOnPrint">
                <button
                    @click="searchCrewActivities"
                    class="btn btn-sm btn-xs btn-secondary mr-1"
                    title="Click to Search"
                >
                  <span class="fas fa-search"></span>
                </button>
                <button
                    @click="resetSearchFields"
                    class="btn btn-sm btn-xs btn-secondary"
                    title="Reset Search Fields"
                >
                  <span class="fas fa-eraser"></span>
                </button>
              </td>
            </tr>

            <tr v-if="isLoading">
              <td colspan="100%">
                <app-loading></app-loading>
              </td>
            </tr>

            <template v-else>
              <tr v-for="(crewActivity, index) in crewActivities" :key="crewActivity.id"
                  :class="{
                              'text-danger': (crewActivity.wrongDate && isSystemAdmin),
                              'bg-silver': (crewActivity.monthDiff > 6 && isSystemAdmin),
                              'text-primary font-weight-bolder': crewActivity.current,
                          }"
              >
                <td class="text-right" v-if="isSystemAdmin">{{ crewActivity.id }}</td>
                <td class="text-right">{{ index + 1 }}</td>

                <td v-if="isSystemAdmin">{{ crewActivity.lastUpdatedBy }}</td>

                <td :title="crewActivity.activityCodeName">

                  <template v-if="(isDesignatedPrincipal || isBremen || isKobe) && !guest">
                    <a href="#"
                       data-toggle="modal" data-target="#crew-activity-comment"
                       @click="getCrewActivity(crewActivity.id)"
                    >
                      {{ crewActivity.activityCode }}
                      <span class="float-right"
                            :title="crewActivity.commentCount + ' comments'"
                            v-if="crewActivity.commentCount"
                      >
                                          {{ crewActivity.commentCount }}
                                      </span>
                    </a>
                  </template>
                  <span v-else>
                                      {{ crewActivity.activityCode }}
                                  </span>

                </td>

                <td v-if="crewActivity.rankName" class="text-center">
                              <span :title="`Onboard as  ${crewActivity.rankName}`">
                                {{ crewActivity.rankName }}
                              </span>
                  <template v-if="crewActivity.osiDescription">
                    -
                    <a href="#" data-toggle="modal" data-target="#osiDescription" @click="() => setOSIDescription(crewActivity.id)"> OSI</a>
                  </template>

                  <template v-if="crewActivity.training_rank_id">
                                <span :title="`Training for ${crewActivity.trainingRankName}`">
                                  <hr class="m-0 border-white"/>
                                  <small
                                      class="text-primary font-weight-bolder">T-{{
                                      crewActivity.trainingRankAlias
                                    }}</small>
                                </span>
                  </template>
                </td>
                <td v-else>
                  {{ crewActivity.assignmentPositionName }}
                </td>

                <!--                              <td :title="crewActivity.rankName ? crewActivity.rankName : crewActivity.assignmentPositionName">-->
                <!--                                  {{ crewActivity.rankAlias ? crewActivity.rankAlias : crewActivity.assignmentPositionName }}-->
                <!--                              </td>-->

                <td v-if="crewActivity.vesselName" :title="crewActivity.vesselTitle">
                  {{ crewActivity.vesselName }}
                </td>
                <td v-else :title="crewActivity.companyOfficeName">
                  {{ crewActivity.companyOfficeAlias }}
                </td>

                <!--                              <td :title="crewActivity.companyOfficeName"-->
                <!--                              >{{ crewActivity.vesselName ? crewActivity.vesselName : crewActivity.companyOfficeAlias }}</td>-->

                <td>{{ crewActivity.vesselType }}</td>

                <td> {{ crewActivity.vesselFlag }}</td>

                <td>{{ crewActivity.start_date | moment('DD MMM YYYY') }}</td>

                <td :title="crewActivity.startStatusName">
                  {{ crewActivity.startStatusCode }}
                </td>

                <td :title="crewActivity.startPortName">
                  {{ crewActivity.startPortCode }}
                </td>

                <td>{{ crewActivity.end_date | moment('DD MMM YYYY') }}</td>

                <td :title="crewActivity.endStatusName">
                  {{ crewActivity.endStatusCode }}
                </td>

                <td :title="crewActivity.endPortName">
                  {{ crewActivity.endPortCode }}
                </td>

                <td :title="crewActivity.endReasonName">
                  {{ crewActivity.endReasonCode }}
                </td>

                <td class="text-right">{{ crewActivity.period }}</td>

                <td class="text-center">
                  <a role="button" @click="viewCer(crewActivity.id)"
                     class="cursor-pointer hover-link"
                  >
                    {{ crewActivity.cers }}
                  </a>
                </td>
                <td :title="parseUpdateInfo(crewActivity)">
                  {{ crewActivity.lastUpdatedAt }}
                </td>

                <td class="text-center hideOnPrint">
                  <template v-if="(crew.active == 1 || isSystemAdmin) && !guest && !isKline">
                    <template v-if="!notToBeReemployed">
                      <button type="button" class="btn btn-sm btn-xs btn-warning mr-1"
                              title="Edit"
                              data-toggle="modal"
                              data-target="#editCrewActivity"
                              @click="updateCrewActivityModal(crewActivity)"
                              v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isBremen"
                      >
                        <span class="fas fa-edit"></span>
                      </button>
                      <button class="btn btn-sm btn-xs btn-outline-danger"
                              title="Delete"
                              @click.prevent="confirmDeleteCrewActivity(crewActivity.id)"
                              v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isBremen"
                      >
                        <span class="fas fa-trash"></span>
                      </button>
                    </template>
                  </template>
                </td>
              </tr>
            </template>

            </tbody>

          </table>
        </form>


      </div>

    </div>

    <div class="modal fade" data-backdrop='static' data-keyboard='false' id="editCrewActivity" tabindex="-1" role="dialog" aria-labelledby="editCrewActivityTitle"
         aria-hidden="true" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isBremen">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="confirmUpdateCrewActivity">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="editCrewActivityTitle">
              Edit Crew Activity
            </h5>
            <button type="button" id="closeEditCrewActivity" @click="refreshCrewActivity" class="close"
                    data-dismiss="modal" aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="row">
              <div class="col col-lg-4 p-0 m-0">
                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.activity_code_id}">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="activityCode">
                    Activity Code:
                  </label>

                  <div class="col col-sm-7">
                    <select id="activityCode" required
                            class="form-control form-control-xs"
                            v-model="crewActivity.activity_code_id"
                            @change="setShoreParams(crewActivity)"
                    >
                      <option :value="null">--- ACTIVITY CODE ---</option>
                      <option v-for="activityCodeKey in activityCodeKeys" :key="activityCodeKey.id"
                              :value="activityCodeKey.id"> {{ activityCodeKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.activity_code_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <template v-if="crewActivity.activity_code_id === 11">
                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.company_office_id }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="company-office-id">
                      Office:
                    </label>

                    <div class="col col-sm-7">
                      <select id="company-office-id"
                              class="form-control form-control-xs"
                              v-model="crewActivity.company_office_id"
                      >
                        <option :value="null">--- Other Office ---</option>
                        <option v-for="companyOfficeKey in companyOfficeKeys" :key="companyOfficeKey.id"
                                :value="companyOfficeKey.id">{{ companyOfficeKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.company_office_id" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.other_office }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="other-office">
                      Other Office:
                    </label>
                    <div class="col col-sm-7">
                      <input type="text" id="other-office" class="form-control form-control-xs"
                             placeholder="Enter Other Office if Applicable"
                             :disabled="crewActivity.company_office_id"
                             v-model="crewActivity.other_office"
                      >
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.other_office" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>

                  <div class="form-group form-row mb-1"
                       :class="{'has-error': crewActivityErrors.assignment_position_id }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                           for="assignment-position-id">
                      Position:
                    </label>

                    <div class="col col-sm-7">
                      <select id="assignment-position-id"
                              class="form-control form-control-xs"
                              v-model="crewActivity.assignment_position_id"
                      >
                        <option :value="null">--- Other Position ---</option>
                        <option v-for="assignmentPositionKey in assignmentPositionKeys" :key="assignmentPositionKey.id"
                                :value="assignmentPositionKey.id">{{ assignmentPositionKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.assignment_position_id" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.other_position }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="other-position">
                      Other Position:
                    </label>
                    <div class="col col-sm-7">
                      <input type="text" id="other-position" class="form-control form-control-xs"
                             placeholder="Enter Other Position if Applicable"
                             :disabled="crewActivity.assignment_position_id"
                             v-model="crewActivity.other_position"
                      >
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.other_position" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>
                </template>

                <template v-else>
                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.rank_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="rankId">
                      Rank:
                    </label>

                    <div class="col col-sm-7">
                      <select id="rankId"
                              class="form-control form-control-xs"
                              v-model="crewActivity.rank_id"
                              @change="setRankAdditional"
                      >
                        <option :value="null">--- RANK ---</option>
                        <option v-for="rankKey in filterRanksWithAdditional" :key="rankKey.alias"
                                :value="rankKey.id"
                                :selected="!rankKey.name.includes('ADDITIONAL') && rankKey.id === crewActivity.rank_id"
                        >{{ rankKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.rank_id" :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>


                  <div class="form-group form-row mb-1 align-items-center" v-if="crewActivity.activity_code_id === 2">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="OSIcheck">
                      OSI? :
                    </label>
                    <div class="col col-sm-7">
                      <input type="checkbox" class="form-check-inline" id="OSIcheck"
                        v-model="osiCheck">
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.osiDescription}"
                       v-if="osiCheck"
                  >
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="OSIDescription">
                      Description:
                    </label>
                    <div class="col col-sm-7">
                      <textarea v-model="crewActivity.osiDescription" id="OSIDescription" class="form-control" style="resize:none"></textarea>
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.osiDescription" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.training_rank_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="training-rank">
                      Training Rank:
                    </label>
                    <div class="col col-sm-7">
                      <select id="training-rank"
                              class="form-control form-control-xs"
                              v-model="crewActivity.training_rank_id"
                              @change="setNewRankAdditional"
                      >
                        <option :value="null">TRAINING RANK (if applicable)</option>
                        <option v-for="rankKey in rankKeys" :key="rankKey.alias"
                                :title="rankKey.alias"
                                :value="rankKey.id">{{ rankKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in crewActivityErrors.training_rank_id" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.vessel_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-vessel">
                      Vessel:
                    </label>

                    <div class="col col-sm-7">

                      <VesselDropdown
                          id="new-vessel"
                          v-model="crewActivity.vessel_id"
                          :selections="vesselKeys"
                          identifier="vessel"
                          :required="requiredVessel"
                          :other-function="getOtherVesselKeys"
                      ></VesselDropdown>

                      <!--                                        <select id="vesselId"-->
                      <!--                                                class="form-control form-control-xs"-->
                      <!--                                                v-model="crewActivity.vessel_id"-->
                      <!--                                                :required="crewActivity.activity_code_id == 2"-->
                      <!--                                        >-->
                      <!--                                            <option :value="null">-&#45;&#45; VESSEL -&#45;&#45;</option>-->
                      <!--                                            <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
                      <!--                                                    :value="vesselKey.id">{{ vesselKey.name }}</option>-->
                      <!--                                        </select>-->

                      <ErrorMessage v-for="(error, index) in crewActivityErrors.vessel_id" :is-visible="error"
                                    :key="index" :message="error" />
                   </div>
                  </div>
                </template>

              </div>

              <div class="col col-lg-4 p-0 m-0">
                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.start_date }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="startDate">
                    Start Date:
                  </label>
                  <div class="col col-sm-7">
                    <input type="date" id="startDate" class="form-control form-control-xs" required
                           v-model="crewActivity.start_date"
                    >
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.start_date" :is-visible="error"
                                  :key="index" :message="error" />
                 </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.start_status_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="startStatusId">
                    Start Status:
                  </label>

                  <div class="col col-sm-7">
                    <select id="startStatusId" class="form-control form-control-xs" :required="requiredActivityStatus"
                            v-model="crewActivity.start_status_id"
                    >
                      <option :value="null">--- START STATUS ---</option>
                      <option v-for="startStatus in activityStatusKeys" :key="startStatus.id"
                              :value="startStatus.id">{{ startStatus.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.start_status_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.start_port_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="startPortId">
                    Start Port:
                  </label>

                  <div class="col col-sm-7">
                    <select id="startPortId"
                            class="form-control form-control-xs"
                            v-model="crewActivity.start_port_id"
                            :disabled="crewActivity.activity_code_id === 11"
                            :required="crewActivity.activity_code_id == 2 && crewActivity.start_status_id == 1"
                    >
                      <option :value="null">--- START PORT ---</option>
                      <option v-for="startPortKey in portKeys" :key="startPortKey.id"
                              :value="startPortKey.id">{{ startPortKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.start_port_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 p-0 m-0">
                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.end_date }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="endDate">
                    End Date:
                  </label>
                  <div class="col col-sm-7">
                    <input type="date" id="endDate"
                           class="form-control form-control-xs"
                           :required="crewActivity.end_status_id === 1"
                           v-model="crewActivity.end_date"
                    >
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.end_date" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.end_status_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="endStatusId">
                    End Status:
                  </label>

                  <div class="col col-sm-7">
                    <select id="endStatusId"
                            class="form-control form-control-xs"
                            v-model="crewActivity.end_status_id"
                    >
                      <option :value="null">--- END STATUS ---</option>
                      <option v-for="endStatus in activityStatusKeys" :key="endStatus.id"
                              :value="endStatus.id">{{ endStatus.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.end_status_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.end_port_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="endPortId">
                    End Port:
                  </label>

                  <div class="col col-sm-7">
                    <select id="endPortId"
                            class="form-control form-control-xs"
                            v-model="crewActivity.end_port_id"
                            :required="crewActivity.end_reason_id !== null"
                            :disabled="crewActivity.activity_code_id === 11"
                    >
                      <option :value="null">--- END PORT ---</option>
                      <option v-for="endPortKey in portKeys" :key="endPortKey.id"
                              :value="endPortKey.id">{{ endPortKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.end_port_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': crewActivityErrors.end_reason_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="endReasonId">
                    End Reason:
                  </label>

                  <div class="col col-sm-7">
                    <select id="endReasonId"
                            class="form-control form-control-xs"
                            v-model="crewActivity.end_reason_id"
                            :required="crewActivity.end_status_id == 1 && crewActivity.activity_code_id == 2"
                    >
                      <option :value="null">--- END REASON ---</option>
                      <option v-for="contractReasonKey in contractReasonKeys" :key="contractReasonKey.id"
                              :value="contractReasonKey.id">{{
                          `${contractReasonKey.code} - ${contractReasonKey.name}`
                        }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in crewActivityErrors.end_reason_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-sm btn-warning font-weight-bolder"
                      :disabled="updating"
              >
                <span class="fas fa-edit"></span>
                {{ updating ? 'Updating Please Wait . . . . .' : 'Update' }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade" data-backdrop='static' data-keyboard='false' id="osiDescription" tabindex="-1" role="dialog" aria-labelledby="osiDescription">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-center">
            <h5 class="modal-title font-weight-bolder" id="osiDescription">
              On-board Superintendent
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <label class="font-weight-bolder text-right">Description: </label>
                <textarea v-model="osiDescription" readonly style="resize:none; background-color: white" rows="10" class="form-control readonly">
                </textarea>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-outline-secondary">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-backdrop='static' data-keyboard='false'  id="addCrewActivity" tabindex="-1" role="dialog" aria-labelledby="addCrewActivityTitle"
         aria-hidden="true" v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff || isBremen">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <form class="modal-content" @submit.prevent="confirmAddCrewActivity">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bolder" id="addCrewActivityTitle">
              Add Crew Activity
            </h5>
            <button type="button" id="closeAddCrewActivity" @click="refreshNewCrewActivity" class="close"
                    data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-lg-4 p-0 m-0">
                <p class="w-100 bg-silver p-1 font-weight-bold text-center">Act/Vessel</p>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.activity_code_id}">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newActivityCode">
                    Activity Code:
                  </label>
                  <div class="col col-sm-7">
                    <select id="newActivityCode" required
                            class="form-control form-control-xs"
                            v-model="newCrewActivity.activity_code_id"
                            @change="setShoreParams(newCrewActivity)"
                    >
                      <option :value="null">--- ACTIVITY CODE ---</option>
                      <option v-for="activityCodeKey in activityCodeKeys" :key="activityCodeKey.id"
                              :value="activityCodeKey.id"> {{ activityCodeKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.activity_code_id" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <template v-if="newCrewActivity.activity_code_id === 11">

                  <div class="form-group form-row mb-1"
                       :class="{'has-error': newCrewActivityErrors.company_office_id }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                           for="new-company-office-id">
                      Office:
                    </label>

                    <div class="col col-sm-7">
                      <select id="new-company-office-id" class="form-control form-control-xs"
                              v-model="newCrewActivity.company_office_id"

                      >
                        <option :value="null">--- Other Office ---</option>
                        <option v-for="companyOfficeKey in companyOfficeKeys" :key="companyOfficeKey.id"
                                :value="companyOfficeKey.id">{{ companyOfficeKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.company_office_id " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.other_office }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-other-office">
                      Other Office:
                    </label>
                    <div class="col col-sm-7">
                      <input type="text" id="new-other-office" class="form-control form-control-xs"
                             placeholder="Enter Other Office if Applicable"
                             :disabled="newCrewActivity.company_office_id"
                             v-model="newCrewActivity.other_office"
                      >
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.other_office " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1"
                       :class="{'has-error': newCrewActivityErrors.assignment_position_id }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                           for="new-assignment-position-id">
                      Position:
                    </label>

                    <div class="col col-sm-7">
                      <select id="new-assignment-position-id" class="form-control form-control-xs"
                              v-model="newCrewActivity.assignment_position_id"
                      >
                        <option :value="null">--- Other Position ---</option>
                        <option v-for="assignmentPositionKey in assignmentPositionKeys" :key="assignmentPositionKey.id"
                                :value="assignmentPositionKey.id">{{ assignmentPositionKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.assignment_position_id " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.other_position }">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="new-other-position">
                      Other Position:
                    </label>
                    <div class="col col-sm-7">
                      <input type="text" id="new-other-position" class="form-control form-control-xs"
                             placeholder="Enter Other Position if Applicable"
                             :disabled="newCrewActivity.assignment_position_id"
                             v-model="newCrewActivity.other_position"
                      >
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.other_position " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                </template>

                <template v-else>
                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.rank_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newRankId">
                      Rank:
                    </label>

                    <div class="col col-sm-7">
                      <select id="newRankId"
                              class="form-control form-control-xs"
                              :required="activityCodesRequiredRanks.includes(newCrewActivity.activity_code_id)"
                              v-model="newCrewActivity.rank_id"
                              @change="setNewRankAdditional"
                      >
                        <option :value="null">--- RANK ---</option>
                        <option v-for="rankKey in filterRanksWithAdditional" :key="rankKey.alias"
                                :title="rankKey.alias"
                                :value="rankKey.id">{{ rankKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.rank_id " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1 align-items-center"  v-if="newCrewActivity.activity_code_id === 2">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newOSI">
                      OSI? :
                    </label>
                    <div class="col col-sm-7">
                      <input type="checkbox" class="form-check-inline" v-model="osiCheck" id="newOSI">
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.osiDescription}"
                    v-if="osiCheck"
                  >
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newOSIDescription">
                      Description:
                    </label>
                    <div class="col col-sm-7">
                      <textarea v-model="newCrewActivity.osiDescription" class="form-control" style="resize:none" id="newOSIDescription"></textarea>
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.osiDescription " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.training_rank_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newRankId">
                      Training Rank:
                    </label>
                    <div class="col col-sm-7">
                      <select id="newRankId"
                              class="form-control form-control-xs"
                              v-model="newCrewActivity.training_rank_id"
                              @change="setNewRankAdditional"
                      >
                        <option :value="null">TRAINING RANK (if applicable)</option>
                        <option v-for="rankKey in rankKeys" :key="rankKey.alias"
                                :title="rankKey.alias"
                                :value="rankKey.id">{{ rankKey.name }}
                        </option>
                      </select>
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.training_rank_id " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>

                  <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.vessel_id}">
                    <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newVesselId">
                      Vessel:
                    </label>

                    <div class="col col-sm-7">

                      <VesselDropdown
                          id="newVesselId"
                          v-model="newCrewActivity.vessel_id"
                          identifier="newVessel"
                          :required="requiredVessel"
                          :selections="vesselKeys"
                          :other-function="getOtherVesselKeys"
                      ></VesselDropdown>

                      <!--                                        <select id="newVesselId"-->
                      <!--                                                class="form-control form-control-xs"-->
                      <!--                                                v-model="newCrewActivity.vessel_id"-->
                      <!--                                                :required="newCrewActivity.activity_code_id == 2"-->
                      <!--                                        >-->
                      <!--                                            <option :value="null">-&#45;&#45; VESSEL -&#45;&#45;</option>-->
                      <!--                                            <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
                      <!--                                                    :value="vesselKey.id">{{ vesselKey.name }}</option>-->
                      <!--                                        </select>-->
                      <ErrorMessage v-for="(error, index) in newCrewActivityErrors.vessel_id " :is-visible="error"
                                    :key="index" :message="error" />
                    </div>
                  </div>
                </template>
              </div>

              <div class="col col-lg-4 p-0 m-0">
                <p class="w-100 bg-silver p-1 font-weight-bold text-center">Start/Embarkation</p>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.start_date }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newStartDate">
                    Start Date:
                  </label>
                  <div class="col col-sm-7">
                    <input type="date" id="newStartDate" class="form-control form-control-xs" required
                           v-model="newCrewActivity.start_date"
                    >
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.start_date " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.start_status_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newStartStatusId">
                    Start Status:
                  </label>

                  <div class="col col-sm-7">
                    <select id="newStartStatusId" class="form-control form-control-xs" :required="requiredActivityStatus"
                            v-model="newCrewActivity.start_status_id"
                    >
                      <option :value="null">--- START STATUS ---</option>
                      <option v-for="startStatus in activityStatusKeys" :key="startStatus.id"
                              :value="startStatus.id">{{ startStatus.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.start_status_id " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.start_port_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newStartPortId">
                    Start Port:
                  </label>

                  <div class="col col-sm-7">
                    <select id="newStartPortId"
                            class="form-control form-control-xs"
                            v-model="newCrewActivity.start_port_id"
                            :disabled="newCrewActivity.activity_code_id === 11"
                            :required="newCrewActivity.activity_code_id == 2 && newCrewActivity.start_status_id == 1"
                    >
                      <option :value="null">--- START PORT ---</option>
                      <option v-for="startPortKey in portKeys" :key="startPortKey.id"
                              :value="startPortKey.id">{{ startPortKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.start_port_id " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>
              </div>

              <div class="col col-lg-4 p-0 m-0">
                <p class="w-100 bg-silver p-1 font-weight-bold text-center">End/Disembarkation</p>
                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.end_date }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newEndDate">
                    End Date:
                  </label>
                  <div class="col col-sm-7">
                    <input type="date" id="newEndDate"
                           class="form-control form-control-xs"
                           v-model="newCrewActivity.end_date"
                           :required="newCrewActivity.end_status_id === 1"
                           :disabled="(newCrewActivity.start_date === null || newCrewActivity.end_status_id === null ||
                           newCrewActivity.start_status_id === null) && activityCodesThatAutomateEndDate.includes(newCrewActivity.activity_code_id) "
                    >
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.end_date" :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.end_status_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newEndStatusId">
                    End Status:
                  </label>

                  <div class="col col-sm-7">
                    <select id="newEndStatusId"
                            class="form-control form-control-xs"
                            v-model="newCrewActivity.end_status_id"
                    >
                      <option :value="null">--- END STATUS ---</option>
                      <option v-for="endStatus in activityStatusKeys" :key="endStatus.id"
                              :value="endStatus.id">{{ endStatus.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.end_status_id " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.end_port_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newEndPortId">
                    End Port:
                  </label>

                  <div class="col col-sm-7">
                    <select id="newEndPortId"
                            class="form-control form-control-xs"
                            :disabled="newCrewActivity.activity_code_id === 11"
                            :required="newCrewActivity.end_reason_id !== null"
                            v-model="newCrewActivity.end_port_id"
                    >
                      <option :value="null">--- END PORT ---</option>
                      <option v-for="endPortKey in portKeys" :key="endPortKey.id"
                              :value="endPortKey.id">{{ endPortKey.name }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.end_port_id " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>

                <div class="form-group form-row mb-1" :class="{'has-error': newCrewActivityErrors.end_reason_id }">
                  <label class="col col-sm-4 col-form-label font-weight-bolder text-right" for="newEndReasonId">
                    End Reason:
                  </label>

                  <div class="col col-sm-7">
                    <select id="newEndReasonId"
                            class="form-control form-control-xs"
                            v-model="newCrewActivity.end_reason_id"
                            :required="newCrewActivity.end_status_id == 1 && newCrewActivity.activity_code_id == 2"
                    >
                      <option :value="null">--- END REASON ---</option>
                      <option v-for="contractReasonKey in contractReasonKeys" :key="contractReasonKey.id"
                              :value="contractReasonKey.id">{{
                          `${contractReasonKey.code} - ${contractReasonKey.name}`
                        }}
                      </option>
                    </select>
                    <ErrorMessage v-for="(error, index) in newCrewActivityErrors.end_reason_id " :is-visible="error"
                                  :key="index" :message="error" />
                  </div>
                </div>
              </div>
            </div>
            <hr class="m-0"/>

            <template>
              <label class="font-weight-bolder text-right"
                     for="new-crew-activity-comment"
              >
                <h6 class="font-weight-bolder mt-3">Comment:</h6>
              </label>

              <div class="text-smaller">
                <div class="row">
                  <div class="col col-sm-8">
                    <div class="form-group form-row mb-1 mt-1">
                                        <textarea rows="4" id="new-crew-activity-comment"
                                                  class="form-control form-control-sm form-control-xs mb-2"
                                                  placeholder="Write Crew Activity Comment Here"
                                                  v-model="newCrewActivity.comment"
                                        ></textarea>
                    </div>
                  </div>
                  <div class="col col-sm-4">
                    <div class="form-group form-row mb-1 mt-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-right"
                             for="new-crew-activity-comment-files"
                      >
                        Attachments:
                      </label>
                      <div class="col col-sm-8" id="new-crew-activity-comment-files-container">
                        <input type="file" id="new-crew-activity-comment-files" multiple
                               accept="application/pdf"
                               class="form-control form-control-sm form-control-xs"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-warning font-weight-bolder"
                    :disabled="saving"
            >
              <span class="fas fa-save"></span>
              {{ saving ? 'Saving Please Wait . . . .' : 'SAVE' }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <CrewActivityComment></CrewActivityComment>
    <CrewActivityExperienceModal></CrewActivityExperienceModal>
  </div>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {formMixin} from "@/mixins/formMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import CrewActivityComment
  from "@/components/sub_components/master_lists/crews/crew_show_components/crew_activities/CrewActivityComment";
import CrewActivityExperienceModal from "@/components/sub_components/master_lists/crews/crew_show_components/crew_activities/CrewActivityExperienceModal";
// import DropdownSelect from "@/components/elements/DropdownSelect";
import VesselDropdown from "@/components/elements/VesselDropdown";
import ErrorMessage from "@/components/elements/ErrorMessage.vue";
import AppLoading from "@/components/elements/AppLoading";
import {DateService} from "@/services/Utilities/DateService";
import {DEATH_CODES} from "@/services/ConstantService";

export default {
  name: "CrewActivity",
  mixins: [vueAppMixin, formMixin, dataMixin, gateMixin],
  components: {
    CrewActivityComment,
    CrewActivityExperienceModal,
    ErrorMessage,
    // DropdownSelect,
    VesselDropdown,
    AppLoading
  },
  data() {
    return {
      activityCodesThatAutomateEndDate: [2, 1, 8, 7],
      activityCodesRequiredRanks: [7,2],
      initialParams: {
        crewId: null,
        actCode: '',
        rank: '',
        vessel: '',
        vesselType: '',
        flag: '',
        startDate: '',
        startStatus: '',
        startPort: '',
        endDate: '',
        endStatus: '',
        endPort: '',
        endReason: '',
        period: '',
        cers: '',
      },
      params: {
        crewId: null,
        actCode: '',
        rank: '',
        vessel: '',
        vesselType: '',
        flag: '',
        startDate: '',
        startStatus: '',
        startPort: '',
        endDate: '',
        endStatus: '',
        endPort: '',
        endReason: '',
        period: '',
        cers: '',
      },
      initialData: {
        activity_code_id: null,
        rank_id: null,
        osiDescription: "",
        training_rank_id: null,
        vessel_id: null,
        start_date: null,
        other_office: null,
        other_position: null,
        start_status_id: null,
        start_port_id: null,
        end_date: null,
        end_status_id: null,
        end_port_id: null,
        end_reason_id: null,
        additional: false,
        company_office_id: null,
        assignment_position_id: null,
      },
      crewActivity: {},
      osiDescription: "",
      crewActivityErrors: {},
      newCrewActivity: {},
      newCrewActivityErrors: {},
      shoreman: false,
      osiCheck: false,
      latestCrewActivityDate: '',
      saving: false,
      updating: false,
      requiredActivityStatus:true,
      requiredVessel:false,
    }
  },

  methods: {
    ...mapActions([
      'getCrewActivities',
      'getRankKeys',
      'getActivityCodeKeys',
      'getVesselKeys',
      'getActivityStatusKeys',
      'getPortKeys',
      'getContractReasonKeys',
      'updateCrewActivity',
      'addCrewActivity',
      'deleteCrewActivity',
      'getCrewInfo',
      'getCrewActivity',
      'getOtherVesselKeys',
      'getCompanyOfficeKeys',
      'getAssignmentPositionKeys',
      'clearCrewActivities'
    ]),

    calculateEndDate() {
      if (this.newCrewActivity.start_date === null ||
          this.newCrewActivity.end_status_id !== 2 ||
        this.newCrewActivity.start_status_id !== 1) {
        this.newCrewActivity.end_date = null;
        return;
      }

      if (this.newCrewActivity.end_status_id === 2)  {
        let startDate = new Date(this.newCrewActivity.start_date);
        let newEndDate = new Date(this.newCrewActivity.start_date);
        newEndDate.setFullYear(startDate.getFullYear() + 1);
        this.newCrewActivity.end_date = DateService.formatDate(newEndDate);
      }
    },

    searchCrewActivities() {
      this.getCrewActivities(this.params);
    },

    async confirmUpdateCrewActivity() {
      if (await this.confirmUpdate()) {
        if (DEATH_CODES.includes(this.crewActivity.activity_code_id) &&
            this.crewActivity.start_date < this.crewActivities[0].start_date &&
            this.crewActivity.id !== this.crewActivities[0].id) {

          this.errorAlert("Cannot update this crew activity to this activity code if its not the latest!", "Updating")
          return;
        }

        let params = {
          'id': this.crewActivity.id,
          'activity_code_id': this.crewActivity.activity_code_id,
          'start_date': this.crewActivity.start_date,
          'start_status_id': this.crewActivity.start_status_id,
          'other_office': this.crewActivity.other_office,
          'other_position': this.crewActivity.other_position,
          'start_port_id': this.crewActivity.start_port_id,
          'end_date': this.crewActivity.end_date,
          'end_status_id': this.crewActivity.end_status_id,
          'end_port_id': this.crewActivity.end_port_id,
          'end_reason_id': this.crewActivity.end_reason_id,
          'additional': this.crewActivity.additional,
          'osiCheck': this.osiCheck,
          'osiDescription': this.crewActivity.osiDescription,
          'vessel_id': null,
          'rank_id': null,
          'company_office_id': null,
          'assignment_position_id': null,
          'updateRank': false,
        };
        if (this.crewActivity.activity_code_id === 11) { // if activity code is shoreman, clear vessel and rank info
          params.company_office_id = this.crewActivity.company_office_id;
          params.assignment_position_id = this.crewActivity.assignment_position_id;
          params.other_office = this.crewActivity.other_office;
          params.other_position = this.crewActivity.other_position;
        } else {

          if (
              this.crewActivity.activity_code_id === 2
              && this.crewActivity.current
              && this.crewActivity.rank_id !== this.crew.rank_id
              && this.crewActivity.start_status_id === 1
          ) {
            params.updateRank = await this.confirmUpdateRankAlert();
          }

          params.vessel_id = this.crewActivity.vessel_id;


          // Remove the letter A being appended to the rank_id when selecting
          // ranks that has a name of "Additional"
          const rankID = this.crewActivity.rank_id;
          if (params.additional || (isNaN(rankID) && rankID.charAt(0) === 'A')) {
            this.crewActivity.rank_id = rankID.slice(1)
          }

          params.rank_id = this.crewActivity.rank_id;
          params.training_rank_id = this.crewActivity.training_rank_id;
        }

        Object.assign(this.params, this.initialParams);
        this.updating = true;
        await this.getCrewActivities(this.params);
        let updateCrewActivity = await this.updateCrewActivity(params);
        this.updating = false;
        if (updateCrewActivity) {
          if (updateCrewActivity.errors) {
            this.crewActivityErrors = updateCrewActivity.errors;
          } else if (updateCrewActivity.customStatus !== undefined && !updateCrewActivity.customStatus) {
            const affectedCrewActivities = updateCrewActivity.affectedCrewActivities;
            this.errorAlert("You are trying to update a Crew Activity that overlaps with number/s: " +
                affectedCrewActivities.map(crewAct => {
                  return this.crewActivities.findIndex(crewActivity => crewActivity.id === crewAct.id) + 1;
                })
                    .join(", "), "Saving"
            );
          } else {

            if (this.crewActivity.activity_code_id === 12) {
              this.crewActivityAlert('Reason: Deceased', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshCrewActivity();
              document.getElementById('closeEditCrewActivity').click();

            }
            else if (this.crewActivity.activity_code_id === 18) {
              this.crewActivityAlert('Reason: Death Ashore', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshCrewActivity();
              document.getElementById('closeEditCrewActivity').click();

            }
            else if (this.crewActivity.activity_code_id === 19) {
              this.crewActivityAlert('Reason: Death onboard', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshCrewActivity();
              document.getElementById('closeEditCrewActivity').click();

            } else if (this.crewActivity.activity_code_id === 9) {
              this.crewActivityAlert('Reason: Not to be re-employed', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshCrewActivity();
              document.getElementById('closeEditCrewActivity').click();

            } else {
              this.successAlert('Crew Activity Successfully Updated', 'UPDATE');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshCrewActivity();
              document.getElementById('closeEditCrewActivity').click();
            }

          }
        }
      }
    },

    setShoreParams(crewActivity) {
      if (crewActivity.activity_code_id === 11) { // if activity code is shoreman, clear vessel and rank info
        crewActivity.vessel_id = null;
        crewActivity.rank_id = null;
        crewActivity.training_rank_id = null;
        crewActivity.end_port_id = null;
        crewActivity.start_port_id = null;
      }
      else { // if not shoreman, clear company office and position
        crewActivity.company_office_id = null;
        crewActivity.assignment_position_id = null;
      }
      this.requiredVessel=[2,19].includes(crewActivity.activity_code_id);
      this.requiredActivityStatus = ![12, 19, 18,9].includes(crewActivity.activity_code_id);
    },

    async confirmAddCrewActivity() {
      if (await this.confirmCreateAlert()) {

        if (this.newCrewActivity.rank_id === null && this.activityCodesRequiredRanks.includes(this.newCrewActivity.activity_code_id)) {
          if (! await this.confirmWarningAlert("Are you sure you want to proceed with this save?", "No Rank Set", "Confirm", "Cancel")) return;
        }

        if (DEATH_CODES.includes(this.newCrewActivity.activity_code_id) &&
            this.newCrewActivity.start_date < this.crewActivities[0].start_date) {
          this.errorAlert("Cannot save this crew activity to this activity code if its not the latest!", "Saving")
          return;
        }

        if (this.newCrewActivity.activity_code_id === 11) { // if activity code is shoreman, clear vessel and rank info
          this.newCrewActivity.vessel_id = null;
          this.newCrewActivity.rank_id = null;
          this.newCrewActivity.end_port_id = null;
          this.newCrewActivity.start_port_id = null;
        } else { // if not shoreman, clear company office and position

          this.newCrewActivity.company_office_id = null;
          this.newCrewActivity.assignment_position_id = null;
          this.newCrewActivity.other_office = null;
          this.newCrewActivity.other_position = null;
          if (
              ((this.crewActivities.length
                  && this.newCrewActivity.start_date > this.crewActivities[0].start_date) || !this.crewActivities.length)
              && this.newCrewActivity.activity_code_id === 2
              && this.crew.rank_id !== this.newCrewActivity.rank_id
              && this.newCrewActivity.start_status_id === 1
          ) {
            this.newCrewActivity['updateRank'] = await this.confirmUpdateRankAlert();
          }
        }

        let formData = new FormData();
        this.newCrewActivity.osiCheck = this.osiCheck ? 1 : 0;
        Object.keys(this.newCrewActivity).forEach(key => {
          let value = this.newCrewActivity[key] ? this.newCrewActivity[key] : '';

          // Remove the letter A being appended to the rank_id when selecting
          // ranks that has a name of "Additional"
          if (key === 'rank_id' && (
              this.newCrewActivity.additional || (isNaN(value) && value.charAt(0) === 'A')
          )) {
            value = value.substr(1)
          }
          formData.append(key, value);
        });
        let fileInput = document.getElementById('new-crew-activity-comment-files');
        if (fileInput.files && fileInput.files[0]) {
          for (let i = 0; i < fileInput.files.length; i++) {
            formData.append(`commentFiles[]`, fileInput.files[i]);
          }
        }

        Object.assign(this.params, this.initialParams);
        this.saving = true;
        await this.getCrewActivities(this.params);
        let newCrewActivity = await this.addCrewActivity(formData);
        this.saving = false;
        if (newCrewActivity) {
          if (newCrewActivity.errors) {
            this.newCrewActivityErrors = newCrewActivity.errors;
          } else if (newCrewActivity.customStatus !== undefined && !newCrewActivity.customStatus) {
            const affectedCrewActivities = newCrewActivity.affectedCrewActivities;
            this.errorAlert("You are trying to save a Crew Activity that overlaps with number/s: " +
                affectedCrewActivities.map(crewAct => {
                  return this.crewActivities.findIndex(crewActivity => crewActivity.id === crewAct.id) + 1;
                })
                    .join(", "), "Saving"
            );
          } else {
            if (this.newCrewActivity.activity_code_id === 12) {
              this.crewActivityAlert('Reason: Deceased', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshNewCrewActivity();
              document.getElementById('closeAddCrewActivity').click();
              this.refreshInputFile('new-crew-activity-comment-files-container');

            } else if (this.newCrewActivity.activity_code_id === 19) {
              this.crewActivityAlert('Reason: Death onboard', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshNewCrewActivity();
              document.getElementById('closeAddCrewActivity').click();
              this.refreshInputFile('new-crew-activity-comment-files-container');

            }
            else if (this.newCrewActivity.activity_code_id === 18) {
              this.crewActivityAlert('Reason: Death Ashore', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshNewCrewActivity();
              document.getElementById('closeAddCrewActivity').click();
              this.refreshInputFile('new-crew-activity-comment-files-container');

            }
            else if (this.newCrewActivity.activity_code_id === 9) {
              this.crewActivityAlert('Reason: Not to be re-employed', 'Crew set to Inactive');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshNewCrewActivity();
              document.getElementById('closeAddCrewActivity').click();
              this.refreshInputFile('new-crew-activity-comment-files-container');

            } else {
              this.successAlert('New Crew Activity Successfully Added', 'CREATE');
              this.getCrewInfo({crewId: this.crew.id});
              this.refreshNewCrewActivity();
              document.getElementById('closeAddCrewActivity').click();
              this.refreshInputFile('new-crew-activity-comment-files-container');
            }
          }
        }
      }
    },

    async initializeData() {
      await this.getCrewActivities(this.params);
      this.getActivityCodeKeys();
      this.getRankKeys();
      if (this.isOchg && !this.isSystemAdmin) {
        let vesselParams = {
          manningId: this.crew.manning_id
        };
        this.getVesselKeys(vesselParams);
      } else {
        this.getVesselKeys();
      }
      this.getActivityStatusKeys();
      this.getPortKeys();
      this.getContractReasonKeys();
      this.getCompanyOfficeKeys();
      this.getAssignmentPositionKeys();
      this.refreshCrewActivity();
      this.refreshNewCrewActivity();
    },

    refreshCrewActivity() {
      this.crewActivity = Object.assign({}, this.initialData);
      this.crewActivityErrors = Object.assign({}, this.initialData);
      this.osiCheck = false;
    },

    refreshNewCrewActivity() {
      this.newCrewActivity = Object.assign({}, this.initialData);
      this.newCrewActivity['crew_id'] = this.crew.id;
      //this.latestCrewActivityDate = this.crewActivities.length ? this.crewActivities[0].end_date : '';
      //this.newCrewActivity.start_date = this.latestCrewActivityDate;
      this.newCrewActivityErrors = Object.assign({}, this.initialData);
      this.osiCheck = false;
      document.querySelector("#new-crew-activity-comment-files").value = "";
    },

    updateCrewActivityModal(crewActivity) {
      this.crewActivity['id'] = crewActivity.id;
      Object.keys(this.crewActivity).forEach(key => this.crewActivity[key] = crewActivity[key]);
      this.osiCheck = this.crewActivity.osiDescription !== "";
      this.crewActivity['current'] = crewActivity.current;
      if (crewActivity.additional) this.crewActivity.rank_id = 'A' + crewActivity.rank_id;
    },

    async confirmDeleteCrewActivity(crewActivityId) {
      if (await this.confirmDeleteAlert()) {
        if (await this.deleteCrewActivity(crewActivityId)) {
          await this.getCrewInfo({crewId: this.crew.id});
          this.successAlert('Crew Activity Successfully Delete', 'DELETE');
        }
      }
    },

    viewCer(crewActivityId) {
      this.$router.push({name: 'CrewCer', params: {id: this.crew.id}});
    },

    // setShoreman(e) {
    //     this.shoreman = e.target.value == 11;
    // },

    setOSIDescription(crewActivityId) {
      const crewActivity = this.crewActivities.find(crewActivity => crewActivity.id === crewActivityId);
      this.osiDescription = crewActivity.osiDescription;
    },

    setNewRankAdditional(e) {
      let selectedRank = e.target.selectedOptions[0].innerHTML;
      this.newCrewActivity.additional = selectedRank.includes('ADDITIONAL') ? 1 : 0;
    },

    setRankAdditional(e) {
      let selectedRank = e.target.selectedOptions[0].innerHTML;
      this.crewActivity.additional = selectedRank.includes('ADDITIONAL') ? 1 : 0;
    },

    parseUpdatedBy(crewActivity) {
      let updatedBy = '------';
      if (crewActivity.updated_by_id) {
        updatedBy = this.fullName(crewActivity.updated_by);
      } else if (crewActivity.created_by_id) {
        updatedBy = this.fullName(crewActivity.created_by);
      }
      return updatedBy;
    },

    resetSearchFields() {
      Object.keys(this.params).forEach(key => {
        this.params[key] = '';
      });
      this.params.crewId = this.crew.id
      this.searchCrewActivities();
    },

    parseUpdateInfo(crewActivity) {
      let updateInfo = '';

      if (crewActivity.createdBy) updateInfo += `Created By: ${crewActivity.createdBy} at ${crewActivity.createdAt}`;
      if (crewActivity.updatedBy) updateInfo += `\nUpdated By: ${crewActivity.updatedBy} at ${crewActivity.updatedAt}`;

      return updateInfo;
    }

  },

  computed: {
    ...mapGetters([
      'crew',
      'crewActivities',
      'rankKeys',
      'activityCodeKeys',
      'vesselKeys',
      'activityStatusKeys',
      'portKeys',
      'contractReasonKeys',
      'rankKeysWithAdditional',
      'companyOfficeKeys',
      'assignmentPositionKeys',
    ]),

    filterRanksWithAdditional () {
      if (this.rankKeys.length === 0) return [];

      const oilerRanks = [14, 8, 16, 18];
      const oilerRanksWithAdditional = oilerRanks.concat(oilerRanks.map(rankId => 'A' + rankId));
      const ableBodiedSeamanRanks = [13, 7, 15,17];
      const ableBodiedSeamanRanksWithAdditional = ableBodiedSeamanRanks.concat(ableBodiedSeamanRanks.map(rankId => 'A' + rankId));
      const messmanRanks = [32, 33, 17, 18, 34];
      const messmanRanksWithAdditional = messmanRanks.concat(messmanRanks.map(rankId => 'A' + rankId));

      if (this.crew.rank_id === 16) return this.rankKeysWithAdditional.filter(rank => oilerRanksWithAdditional.includes(rank.id));
      if (this.crew.rank_id === 15) return this.rankKeysWithAdditional.filter(rank => ableBodiedSeamanRanksWithAdditional.includes(rank.id));
      if (this.crew.rank_id === 34) return this.rankKeysWithAdditional.filter(rank => messmanRanksWithAdditional.includes(rank.id));

      const rankKey = this.rankKeysWithAdditional.find(rankKey => rankKey.id === this.crew.rank_id);

      if (![16, 15, 34].includes(this.crew.rank_id) && rankKey.rank_type_id !== null)
        return this.rankKeysWithAdditional.filter(rank => {
          if(this.crew.rank_id!== 18) {
            return  rank.rank_type_id === rankKey.rank_type_id
          }
          return rank.rank_type_id === rankKey.rank_type_id || rank.id === 34
        });



      return this.rankKeys;
    }
  },

  async created() {
    this.params.crewId = this.crew.id;
    this.initialParams.crewId = this.crew.id;
    await this.initializeData();
  },

  watch: {
    'newCrewActivity.assignment_position_id'() {
      if (this.newCrewActivity.assignment_position_id) {
        this.newCrewActivity.other_position = '';
      }
    },
    'newCrewActivity.activity_code_id'() {
      if (this.newCrewActivity.activity_code_id !== 2) {
        this.osiCheck = false;
      }
    },
    'newCrewActivity.company_office_id'() {
      if (this.newCrewActivity.company_office_id) {
        this.newCrewActivity.other_office = '';
      }
    },
    'newCrewActivity.start_date'() {
      this.calculateEndDate();
    },
    'newCrewActivity.start_status_id'() {
      this.calculateEndDate();
    },
    'newCrewActivity.end_status_id'() {
      this.calculateEndDate();
    },
    'crewActivity.assignment_position_id'() {
      if (this.crewActivity.assignment_position_id) {
        this.crewActivity.other_position = '';
      }
    },
    'crewActivity.activity_code_id'() {
      if (this.crewActivity.activity_code_id !== 2) {
        this.osiCheck = false;
      }
    },
    'crewActivity.company_office_id'() {
      if (this.crewActivity.company_office_id) {
        this.crewActivity.other_office = '';
      }
    },
    osiCheck() {
      if (!this.osiCheck) {
        this.newCrewActivity.osiDescription = "";
        this.crewActivity.osiDescription = "";
      }
    }
  },

  destroyed() {
    this.clearCrewActivities();
  }
}
</script>

<style scoped>
.col-date {
  width: 100px !important;
}

.modal-lg, .modal-xl {
  max-width: 1150px;
}

@media print {
  .hideOnPrint {
    display: none;
  }
}
</style>
